import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionIcon, Group, Text } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { FormattedMessage } from "react-intl";
import { memo } from "react";
export const MarkerListHeader = memo(({ onClose }) => {
    return (_jsxs(Group, { justify: "space-between", align: "center", children: [_jsx(Text, { fw: 600, fz: 16, children: _jsx(FormattedMessage, { id: "heading.markers", defaultMessage: "Markers" }) }), _jsx(ActionIcon, { variant: "subtle", color: "gray", size: 32, onClick: onClose, children: _jsx(IconX, { size: 20, stroke: 1.5 }) })] }));
});
MarkerListHeader.displayName = "MarkerListHeader";
